import { Trans } from "react-i18next";

import util from "utils/utils";

import FormattedComment from "components/lib/FormattedComment";

import type { AppNotification, NotificationEvent } from "../types";

type MentionConfig = {
  type: string;
  message: string;
  link: string;
  location: string;
  id?: string;
};

type MentionedContentProps = {
  notification: AppNotification;
  mentions: MentionConfig[];
  events?: NotificationEvent[];
  notificationType?: string;
};

export default function MentionedContent({
  notification,
  mentions,
  events = [],
  notificationType,
}: MentionedContentProps) {
  const mentionedInfo = mentions.find((f) => f.type === notificationType);

  const mentionId = mentionedInfo?.id;
  const hasType = mentionId && notification[mentionId as keyof AppNotification];
  if (hasType && mentionId) {
    const letter = mentionId.charAt(0).toUpperCase();
    const ownerName =
      `owner${letter}${mentionId.slice(1)}` as keyof AppNotification;
    const ownerItem = notification[ownerName] as {
      name?: string;
      title?: string;
    };

    if (ownerItem) {
      return (
        <Trans
          i18nKey="notifications.mentionedComment"
          values={{
            name: util.getEventNames(events ?? []),
            mentionedInfo: `mentioned you in the ${mentionId}`,
            mentionedName: ownerItem?.name || ownerItem?.title || "Deleted",
            comment: events[0]?.commentText || "",
          }}
          components={{
            b: <b />,
            formattedComment: <FormattedComment noLink maxLength={100} />,
          }}
        />
      );
    }
  }

  return (
    <Trans
      i18nKey="notifications.mentionedComment"
      values={{
        name: util.getEventNames(events ?? []),
        mentionedInfo:
          mentionedInfo ? mentionedInfo.message : "No message found",
        mentionedName: "",
        comment: events[0]?.commentText || "",
      }}
      components={{
        b: <b />,
        formattedComment: <FormattedComment noLink maxLength={100} />,
      }}
    />
  );
}
